import api from './api';
import { categoryStore, productStore, productDownloadStore } from './stores';

export async function getCategories() {
    try {
        categoryStore.requestCategories();
        categoryStore.receiveCategories(await api.get('categories'));
    } catch (error) {
        categoryStore.error(error);
    }
}

export async function getProducts({ page, category, search }) {
    try {
        productStore.requestProducts({ page, category, search });
        productStore.receiveProducts(await api.get('products', { page, category, search }));
    } catch (error) {
        productStore.error(error);
    }
}

export async function createOrder(product_id, download_id) {
    try {
        productDownloadStore.requestProductDownload(product_id);
        const response = await api.post('orders', { product_id, download_id });
        productDownloadStore.receiveProductDownload(product_id);

        return window.location.assign(response.download_url);
    } catch (e) {
        productDownloadStore.error(product_id, e.message);
    }
}
